'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['', ''], ['', '']);

var _graphql = require('graphql');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (client) {
    return client.query({ query: (0, _graphqlTag2.default)(_templateObject, _graphql.introspectionQuery) }).then(function (_ref) {
        var __schema = _ref.data.__schema;
        return __schema;
    });
};


//////////////////
// WEBPACK FOOTER
// ./~/aor-simple-graphql-client/lib/introspection/fetchSchema.js
// module id = 935
// module chunks = 0